<script setup lang="ts">
defineProps<{
  visible: boolean
}>()
</script>

<template>
  <div
    :class="visible ? 'translate-y-0' : '-translate-y-full md:translate-y-0'"
    class="sticky top-0 z-40 w-full flex-none transform bg-white/95 backdrop-blur transition-colors transition-transform duration-500 ease-in-out lg:z-50 lg:border-b dark:border-slate-50/[0.06] lg:border-slate-900/10 dark:bg-transparent"
  >
    <div class="bg-main-300/95">
      <div
        class="mx-auto max-w-[88rem] w-full px-2 py-4 lg:px-8 sm:px-4 lg:divide-y lg:divide-slate-200"
      >
        <div
          class="relative flex justify-between lg:mx-0 lg:border-0 dark:border-slate-300/10"
        >
          <!-- Logo -->
          <div class="flex flex-1 items-center px-2 lg:px-0">
            <!-- Search bar -->
            <div class="max-w-lg w-full">
              <slot name="logo" />
            </div>
          </div>

          <div class="flex shrink-0 items-center">
            <div class="flex flex-1 justify-start">
              <slot name="center" />
            </div>
          </div>

          <!-- Navigation items -->
          <div class="flex flex-1 items-center justify-end">
            <slot name="right" />
          </div>
        </div>
      </div>
    </div>

    <div class="mx-auto max-w-[88rem] w-full px-2 lg:px-8 sm:px-4 md:pt-2 lg:divide-y lg:divide-slate-200">
      <div class="relative mx-4 flex justify-between lg:mx-0">
        <!-- TAG BOTTOM BAR -->
        <div v-if="$slots.navbar" class="h-14 overflow-hidden border-slate-900/10 hidden lg:block dark:border-slate-50/[0.06]">
          <slot name="navbar" />
        </div>
      </div>
    </div>

    <div v-if="$slots.search" class="w-full flex px-4 py-3 shadow md:hidden">
      <slot name="search" />
    </div>
  </div>
</template>
